import { Breadcrumbs, Link, Box } from "@mui/material";
import { useEffect, useState } from "react";

//icons
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeIcon from "@mui/icons-material/Home";
import BookIcon from "@mui/icons-material/Book";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArticleIcon from "@mui/icons-material/Article";

function BreadCrumb(props) {
  const [path, setPath] = useState([
    {
      name: "home",
      href: "/",
      icon: <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
    },
  ]);

  useEffect(() => {
    function generateBreadcrumb() {
      const obj = [
        {
          name: "home",
          href: "/",
          icon: <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
        },
      ];
      window.location.pathname.split("/").forEach((link) => {
        let name, icon;
        switch (link) {
          case "chi-sono":
            name = "Chi sono";
            icon = <AccountCircleIcon sx={{ mr: 0.5 }} fontSize="inherit" />;
            break;
          case "blog":
            name = "Blog";
            icon = <BookIcon sx={{ mr: 0.5 }} fontSize="inherit" />;
            break;
          default:
            name = props.customTitle ? props.customTitle : "";
            icon = <ArticleIcon sx={{ mr: 0.5 }} fontSize="inherit" />;
            break;
        }
        if (link !== "") {
          obj.push({
            name,
            href: "/" + link,
            icon,
          });
        }
      });

      setPath(obj);
    }
    generateBreadcrumb();
  }, [props]);

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          "& .MuiBreadcrumbs-separator": {
            mx: { xs: 0.5, sm: 1 },
          },
        }}
      >
        {path &&
          path.length > 0 &&
          path.map((link, key) => {
            const isLast = key === path.length - 1;

            return (
              <Link
                key={key}
                underline={isLast ? "none" : "hover"}
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  textTransform: "capitalize",
                  fontFamily: "PlayfairDisplay-Regular",
                  color: isLast ? "text.primary" : "#145444",
                  fontWeight: isLast ? "bold" : "normal",
                  fontSize: { xs: "1rem", sm: "1rem" },
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "none",
                  "&:hover": {
                    textDecoration: isLast ? "none" : "underline",
                  },
                }}
                color="inherit"
                href={isLast ? "#" : link.href}
                aria-current={isLast ? "page" : undefined}
              >
                <Box component="span" sx={{ display: "inline-flex", mr: 0.5 }}>
                  {link.icon}
                </Box>
                <Box
                  component="span"
                  sx={{
                    display: "inline-block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {link.name}
                </Box>
              </Link>
            );
          })}
      </Breadcrumbs>
    </Box>
  );
}

export default BreadCrumb;
